import { useEffect } from "react";
import { TezosToolkit } from "@taquito/taquito";
import { BeaconWallet } from "@taquito/beacon-wallet";
import {
  NetworkType,
  BeaconEvent,
  defaultEventCallbacks
} from "@airgap/beacon-dapp";


interface SyncButtonProps {
  core: any;
  synced: any;
  setSynced: any;
}

export const SyncButton = ({ core, synced, setSynced }: SyncButtonProps) => {

  const sync = async (): Promise<void> => {
    await core.connectWallet(setSynced);
  };

  const unsync = async (): Promise<void> => {
    await core.disconnectWallet(setSynced);
  }

  useEffect(() => {
    const exec = async (): Promise<void> => {
      await core.autoConnectWallet();
      setSynced(core.beaconConnection);
    };
    exec().catch(console.error);
  }, [core,setSynced]);

  if (synced === false) {
    return (
      <div>
        <button className="button" onClick={sync}>
          Connect wallet
        </button>
      </div>
    );
  }
  else {
    return (
      <div>
        <button className="button" onClick={unsync}>
          Disconnect wallet
        </button>
      </div>
    );
  }
};

export class DappCore {
  
  rpcUrl: string;
  Tezos: TezosToolkit;
  wallet: any; //BeaconWallet;
  userAddress: string;
  beaconConnection: boolean;
  publicToken: string | null;
  state: any;

  constructor() {
    this.rpcUrl = "https://rpc.tzbeta.net/";
    //this.rpcUrl = "https://ghostnet.smartpy.io/";
    this.Tezos = new TezosToolkit(this.rpcUrl);
    this.wallet = null;
    this.userAddress = "";
    this.beaconConnection = false;
    this.publicToken = "";
  }

  setPublicToken(data) {
    this.publicToken = data.publicKey;
  }

  infer_network() {
    if (this.rpcUrl.includes("ithaca")) {
      return NetworkType.ITHACANET;
    }
    else if (this.rpcUrl.includes("hangzhou")) {
      return NetworkType.HANGZHOUNET;
    }
    else if (this.rpcUrl.includes("granada")) {
      return NetworkType.GRANADANET;
    }
    else if (this.rpcUrl.includes("jakarta")) {
      return NetworkType.JAKARTANET;
    }
    else if (this.rpcUrl.includes("ghostnet")) {
      return NetworkType.GHOSTNET;
    }
    return NetworkType.MAINNET;
  }

  createWallet () {
    const wallet = new BeaconWallet({
      name: "Example Dapp",
      preferredNetwork: this.infer_network(),
      disableDefaultEvents: true, // Disable all events / UI. This also disables the pairing alert.
      eventHandlers: {
        // To keep the pairing alert, we have to add the following default event handlers back
        [BeaconEvent.PAIR_INIT]: {
          handler: defaultEventCallbacks.PAIR_INIT
        },
        [BeaconEvent.PAIR_SUCCESS]: {
          handler: data => this.setPublicToken(data)
        }
      }
    });
    this.Tezos.setWalletProvider(wallet);
    this.wallet = wallet;
  }

  connectWallet = async (setter): Promise<void> => {
    try {
      if (this.wallet === null) {
        this.createWallet();
      }
      await this.wallet.requestPermissions({
        network: {
          type: this.infer_network(),
          rpcUrl: this.rpcUrl
        }
      });
      // gets user's address
      const userAddress = await this.wallet.getPKH();
      console.log(userAddress);
      this.userAddress = userAddress;
      this.beaconConnection = true;
      setter(this.beaconConnection);
    } catch (error) {
      console.log(error);
    }
  };

  disconnectWallet = async (setter): Promise<void> => {
    try {
      console.log("DESTROY");
      this.userAddress = "";
      this.Tezos = new TezosToolkit(this.rpcUrl);
      this.beaconConnection = false;
      this.publicToken = null;
      if (this.wallet) {
        await this.wallet.client.removeAllAccounts();
        //await this.wallet.client.removeAllPeers();
        //await this.wallet.client.destroy();
      }
      this.wallet = null;
      setter(this.beaconConnection);
    } catch (error) {
      console.log(error);
    }
  };

  autoConnectWallet = async (): Promise<void> => {
    if (this.wallet === null) {
      this.createWallet();
    }
    const activeAccount = await this.wallet.client.getActiveAccount();
    if (activeAccount) {
      const userAddress = await this.wallet.getPKH();
      this.userAddress = userAddress;
      this.beaconConnection = true;
    }
  };

  tzkt_query = async (url): Promise<any> => {
    try {
      const base_url = "https://api.mainnet.tzkt.io/v1/";
      console.log(base_url + url);
      let response = await fetch(base_url + url);
      let data = await response.json();
      return data;
    } catch (error) {
      console.log("TZKT QUERY FAILED ....");
      console.log(error);
    }
    return null;
  }

};